(function () {
  document.querySelectorAll('.js-lc-faq-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.lc-lfaq__item');
      var answer = item.querySelector('.js-lc-faq-answer');
      var isOpen = item.classList.contains('is-open');

      document.querySelectorAll('.lc-lfaq__item.is-open').forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.js-lc-faq-toggle').setAttribute('aria-expanded', 'false');
          openItem.querySelector('.js-lc-faq-answer').style.maxHeight = null;
        }
      });

      if (isOpen) {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
})();
